import { ChangeDetectorRef, ElementRef, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { ASC } from 'Angular/constants/core.constants';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { ToastMessageType } from 'Angular/features/components/toast-messages/toast-messages.enum';
import { FolderCollectionViewSortColumn } from 'FoldersApp/enums/folder-views.enums';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { FolderOperationsService } from 'FoldersApp/services/folder-operations.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { formFlattenedObject } from 'Angular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i3 from "FoldersApp/services/folder-operations.service";
import * as i4 from "Angular/features/components/toast-messages/page-toast-messages-service";
var MoveModalView;
(function (MoveModalView) {
    MoveModalView["CREATE"] = "create";
    MoveModalView["MOVE"] = "move";
})(MoveModalView || (MoveModalView = {}));
export class FolderableMoveModalDirective {
    get ancestorFolderId() {
        const { ancestors } = this.modalViewRootFolder;
        return ancestors[ancestors.length - 1]?.id || null;
    }
    get cannotCreateFolder() {
        return !this.modalViewRootFolder.permissions?.canEdit;
    }
    get viewRootFolderName() {
        if (!this.modalViewRootFolder)
            return '';
        return this.modalViewRootFolder.id === null
            ? this.folderableAppConfig.itemNamePlural
            : this.modalViewRootFolder.name;
    }
    constructor(store, folderCollectionService, folderOperationsService, eltRef, toastMessagesService) {
        this.store = store;
        this.folderCollectionService = folderCollectionService;
        this.folderOperationsService = folderOperationsService;
        this.eltRef = eltRef;
        this.toastMessagesService = toastMessagesService;
        this.MoveModalView = MoveModalView;
        this.unsubscribe = new Subject();
        this.folderableAppConfig = inject(FOLDERABLE_APP_CONFIG);
        this.changeDetectorRef = inject(ChangeDetectorRef);
        this.moveItemSubscription = null;
        this.getFoldersSubscription = null;
        this.modalViewRootFolder = null;
        this.folders = [];
        this.viewStyle = MoveModalView.MOVE;
        this.newFolderName = '';
        this.open = false;
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    toggleView() {
        if (this.viewStyle === MoveModalView.MOVE) {
            this.newFolderName = '';
            this.viewStyle = MoveModalView.CREATE;
            // Wait for create view to be rendered before attempting find and focus the element.
            setTimeout(() => {
                const el = document.querySelector(`#folderNameInput`);
                if (el)
                    el.focus();
            });
        }
        else {
            this.viewStyle = MoveModalView.MOVE;
        }
    }
    closeModal() {
        if (this.getFoldersSubscription)
            this.getFoldersSubscription.unsubscribe();
        this.open = false;
        this.newFolderName = '';
        this.viewStyle = MoveModalView.MOVE;
        this.store.dispatch(setSelectedFolderableOperation({ selectedOperation: null }));
    }
    mouseEventHandler(event) {
        if (!this.open)
            return;
        if (event && !this.eltRef.nativeElement.contains(event.target)) {
            this.closeModal();
        }
    }
    setModalViewRootFolder(folderId) {
        if (folderId === undefined)
            return;
        const queryParams = {
            owner: { me: true, shared_with_me: true, public: true },
            name: '',
            sortColumn: FolderCollectionViewSortColumn.MODIFY_DATE,
            sortDirection: ASC,
            viewDepth: 1,
            viewRootFolder: folderId,
            includeEmptyFolders: true,
        };
        const queryParams_ = formFlattenedObject(queryParams, Object.keys(queryParams));
        this.getFoldersSubscription = this.folderOperationsService
            .getFolders(queryParams_)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe({
            next: (response) => {
                this.modalViewRootFolder = response.viewRootFolder;
                this.folders = response.data.items.map((folderItem) => folderItem.item);
                this.viewStyle = MoveModalView.MOVE;
                this.changeDetectorRef.markForCheck();
            },
            error: (response) => {
                this.toastMessagesService.addMessage(response.error.error_message, ToastMessageType.ERROR);
            },
        });
    }
    /**
     * Create a folder inside the modal view root folder.
     */
    createFolder() {
        if (this.modalViewRootFolder === null)
            return;
        const postParams = {
            folderName: this.newFolderName,
        };
        if (this.modalViewRootFolder.id) {
            postParams.targetFolderId = this.modalViewRootFolder.id;
        }
        this.folderOperationsService.createFolder(postParams).subscribe({
            next: (response) => {
                this.setModalViewRootFolder(response.folderId);
                this.folderCollectionService.refreshData();
                this.toastMessagesService.addMessage(`Created folder "${this.newFolderName}".`);
            },
            error: (_) => {
                this.toastMessagesService.addMessage('There was an error creating a new folder. Please try again.', ToastMessageType.ERROR);
            },
        });
    }
}
FolderableMoveModalDirective.ɵfac = function FolderableMoveModalDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableMoveModalDirective)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i3.FolderOperationsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i4.PageToastMessagesService)); };
FolderableMoveModalDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableMoveModalDirective, hostBindings: function FolderableMoveModalDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("mousedown", function FolderableMoveModalDirective_mousedown_HostBindingHandler($event) { return ctx.mouseEventHandler($event); }, i0.ɵɵresolveWindow)("touchend", function FolderableMoveModalDirective_touchend_HostBindingHandler($event) { return ctx.mouseEventHandler($event); }, i0.ɵɵresolveWindow);
    } } });
